module.exports = __webpack_public_path__ + "img/TürkischeMelisse_Feld2.e8848cbe.jpg";